import { restClient } from '../config/restClient'

const endpoint = candidateProfileId => `/api/company/v2/candidate_profiles/${candidateProfileId}/calendar_availabilities`

export const getCandidateCalendarAvailabilities = async candidateProfileId => {
  const response = await restClient(endpoint(candidateProfileId), {
    method: 'GET',
  })
  return response.data
}
